import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

const ErrorDisplay = ({ error, errorInfo, isDevelopment = false, onResetClick }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div style={{
      padding: '40px 32px',
      color: theme.palette.error.main,
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.background.default
    }}
    >
      <h1 style={{ fontSize: '32px', marginTop: '0' }}>
        {t('ErrorBoundary_Title')}
      </h1>
      <p style={{ fontSize: '16px', marginBottom: '20px', color: theme.palette.text.secondary }}>
        {t('ErrorBoundary_Message')}
      </p>

      {isDevelopment && error && (
        <details style={{
          textAlign: 'left',
          backgroundColor: theme.palette.action.hover,
          padding: '16px',
          borderRadius: '4px',
          margin: '20px 0',
          fontSize: '12px',
          maxWidth: '600px',
          border: `1px solid ${theme.palette.divider}`
        }}
        >
          <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '10px', color: theme.palette.text.primary }}>
            {t('ErrorBoundary_Details')}
          </summary>

          <pre style={{
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            color: theme.palette.error.dark,
            margin: '10px 0 0 0'
          }}
          >
            {error.message || error.toString()}
          </pre>
          {(error.stack || errorInfo?.componentStack) && (
            <pre style={{
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              color: theme.palette.text.secondary,
              margin: '10px 0 0 0',
              fontSize: '11px'
            }}
            >
              {error.stack || errorInfo?.componentStack}
            </pre>
          )}
        </details>
      )}

      <button
        type="button"
        onClick={onResetClick}
        style={{
          padding: '10px 24px',
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          transition: 'background-color 0.2s ease'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = theme.palette.primary.dark}
        onMouseOut={(e) => e.target.style.backgroundColor = theme.palette.primary.main}
        onFocus={(e) => e.target.style.backgroundColor = theme.palette.primary.dark}
        onBlur={(e) => e.target.style.backgroundColor = theme.palette.primary.main}
      >
        {t('ErrorBoundary_GoHome')}
      </button>
    </div>
  );
};

export default ErrorDisplay;
